import { get as getConstants } from '@lumapps/constants';
import { isFeatureEnabled } from '@lumapps/features';
import { useSelector } from '@lumapps/redux/react';
import { AppId } from '@lumapps/router';

import { SEARCH_SEGMENTED_FF } from '../constants';

export const useSegmentedSearch = () => {
    const { applicationId } = getConstants();
    const isSegmentedEnabled = useSelector(isFeatureEnabled(SEARCH_SEGMENTED_FF));
    const isWebview = applicationId === AppId.webview;

    return {
        isSegmentedEnabled,
        isWebview,
        isSegmentedWebview: isWebview,
        /** Segmented search on any browser viewport (mobile or desktop), excluding the webview app. */
        isSegmentedWeb: isSegmentedEnabled && !isWebview,
    };
};
